import React from 'react';
import { withParentSize } from '@visx/responsive';
import useBoneBackgroundColor from 'Hooks/useBoneBackgroundColor';
import PropTypes from 'prop-types';
import { Visualization, VisualizationIcons } from './Visualization';
import { Compact } from './Compact';

export const MoneyMovement = withParentSize(({ parentWidth, resource, backgroundColor }) => {
  useBoneBackgroundColor();

  if (parentWidth < 600) {
    return (<Compact resource={resource} />);
  }
  return (
    <>
      <VisualizationIcons />
      <Visualization chartId={`money-movement-${resource.id()}`} width={parentWidth} resource={resource} backgroundColor={backgroundColor} />
    </>
  );
});

MoneyMovement.defaultProps = {
  resource: undefined,
};

MoneyMovement.propTypes = {
  resource: PropTypes.object,
};
